import React, { useState, useEffect } from 'react';

const BlockSelection = ({ formData, updateFormData, nextStep }) => {
  // Initialize selectedTower from formData.tower, ensuring it's a string
  const [selectedTower, setSelectedTower] = useState(formData.tower ? String(formData.tower) : '');
  
  const blocks = [
    { id: 'A', name: 'A', towers: 23 },
    { id: 'B', name: 'B', towers: 19 },
    { id: 'C', name: 'C', towers: 15 },
    { id: 'D', name: 'D', towers: 8 }
  ];
  
  // Sync selectedTower with formData.tower when formData.tower changes externally
  useEffect(() => {
    if (formData.tower) {
      setSelectedTower(String(formData.tower));
    }
  }, [formData.tower]);
  
  // Reset tower selection when block changes
  useEffect(() => {
    setSelectedTower('');
    updateFormData({ tower: '' });
  }, [formData.block, updateFormData]);
  
  const handleBlockSelect = (blockId) => {
    // Reset selectedTower when block changes
    setSelectedTower('');
    
    updateFormData({ block: blockId, tower: '' });
  };
  
  const handleTowerSelect = (tower) => {
    // Convert to string to ensure consistent type
    const towerValue = String(tower);
    console.log('Tower selected:', towerValue);
    
    // Update local state
    setSelectedTower(towerValue);
    
    updateFormData({ tower: towerValue });
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submission - formData:', formData);
    console.log('Form submission - selectedTower:', selectedTower);
    
    if (!formData.block) {
      alert('Please select a block before proceeding.');
      return;
    }
    
    // Check if tower is selected using the local state
    if (!selectedTower) {
      alert('Please select a tower before proceeding.');
      return;
    }
    
    updateFormData({ tower: selectedTower });
    setTimeout(() => nextStep(), 0);
  };
  
  return (
    <div>
      <h2 className="text-2xl font-semibold mb-6">Select Your Block</h2>
      <p className="mb-6 text-gray-600">
        Please select the block where you reside in Sapna Enclave.
      </p>
      
      <form onSubmit={handleSubmit}>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
          {blocks.map((block) => (
            <button
              key={block.id}
              type="button"
              onClick={() => handleBlockSelect(block.id)}
              className={`
                h-32 flex flex-col items-center justify-center rounded-lg
                transition-all duration-200 border-2 p-4
                ${
                  formData.block === block.id
                    ? 'bg-blue-600 text-white border-blue-700'
                    : 'bg-white text-gray-800 border-gray-300 hover:border-blue-500'
                }
              `}
            >
              <span className="text-2xl font-bold mb-1">Block {block.name}</span>
              <span className={`text-sm ${
                formData.block === block.id ? 'text-blue-100' : 'text-gray-600'
              }`}>
                {block.towers} {block.towers === 1 ? 'Tower' : 'Towers'}
              </span>
            </button>
          ))}
        </div>
        
        {formData.block && (
          <div className="mt-8">
            <h3 className="text-xl font-semibold mb-4">Select Your Tower</h3>
            <p className="mb-4 text-gray-600">
              Please select your tower number in Block {formData.block}.
            </p>
            
            <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-8 gap-3 mb-8">
              {Array.from({ length: blocks.find(b => b.id === formData.block)?.towers || 0 }, (_, i) => i + 1).map((tower) => (
                <button
                  key={tower}
                  type="button"
                  onClick={() => handleTowerSelect(tower)}
                  className={`
                    h-12 flex items-center justify-center rounded-md
                    transition-all duration-200 border
                    ${
                      selectedTower === String(tower)
                        ? 'bg-blue-600 text-white border-blue-700'
                        : 'bg-white text-gray-800 border-gray-300 hover:border-blue-500'
                    }
                  `}
                >
                  {tower}
                </button>
              ))}
            </div>
          </div>
        )}
        
        <div className="flex justify-end">
          <button
            type="submit"
            className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded focus:outline-none focus:shadow-outline"
          >
            Next
          </button>
        </div>
      </form>
    </div>
  );
};

export default BlockSelection;
